// Types and data for demo thought tracer
export type DemoOperationType = 'DATA_PROCESSING' | 'SEARCH_QUERY' | 'DOCUMENT_ANALYSIS';

export const demoOperations: Record<DemoOperationType, { message: string; delay: number }[]> = {
  DATA_PROCESSING: [
    { message: 'Starting data processing operation...', delay: 100 },
    { message: 'Loading dataset from storage...', delay: 800 },
    { message: 'Validating data integrity...', delay: 1200 },
    { message: 'Processing data records...', delay: 2000 },
    { message: 'Applying transformations...', delay: 1500 },
    { message: 'Calculating aggregates...', delay: 1800 },
    { message: 'Preparing final results...', delay: 1000 },
    { message: 'Operation completed', delay: 600 }
  ],
  SEARCH_QUERY: [
    { message: 'Starting search operation...', delay: 50 },
    { message: 'Parsing search query...', delay: 300 },
    { message: 'Optimizing search parameters...', delay: 500 },
    { message: 'Searching document index...', delay: 1500 },
    { message: 'Ranking results...', delay: 800 },
    { message: 'Applying relevance filters...', delay: 700 },
    { message: 'Retrieving document metadata...', delay: 600 },
    { message: 'Formatting results...', delay: 400 },
    { message: 'Operation completed', delay: 150 }
  ],
  DOCUMENT_ANALYSIS: [
    { message: 'Starting document analysis...', delay: 80 },
    { message: 'Extracting document structure...', delay: 600 },
    { message: 'Identifying key entities...', delay: 1200 },
    { message: 'Processing document sections...', delay: 1500 },
    { message: 'Analyzing semantic relationships...', delay: 2200 },
    { message: 'Generating document summary...', delay: 1000 },
    { message: 'Compiling analysis report...', delay: 800 },
    { message: 'Operation completed', delay: 200 }
  ]
};
